/**
 * Wishlist buttons for product grids.
 * Reads/writes the SAME localStorage key ("toy_wishlist") and object shape
 * ({ id, title, url, image, price }) already used by the PDP wishlist
 * heart and the wishlist drawer, and fires the same 'toy:wishlist:updated'
 * event so everything (drawer count, PDP heart, other grid buttons)
 * stays in sync without a page reload.
 */
(function () {
  var STORAGE_KEY = 'toy_wishlist';

  function getWishlist() {
    try {
      var list = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      var clean = list.filter(function (item) {
        return item && typeof item === 'object' && item.id && item.title;
      });
      if (clean.length !== list.length) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(clean));
      }
      return clean;
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('toy:wishlist:updated'));
  }

  function isWishlisted(id) {
    return getWishlist().some(function (item) { return item.id == id; });
  }

  function refreshButtons() {
    document.querySelectorAll('[data-toy-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      btn.classList.toggle('active', isWishlisted(id));
    });
  }

  function toggle(btn) {
    var id = btn.getAttribute('data-product-id');
    var list = getWishlist();
    var idx = list.findIndex(function (item) { return item.id == id; });

    if (idx === -1) {
      list.push({
        id: id,
        title: btn.getAttribute('data-product-title') || '',
        url: btn.getAttribute('data-product-url') || '',
        image: btn.getAttribute('data-product-image') || '',
        price: btn.getAttribute('data-product-price') || ''
      });
    } else {
      list.splice(idx, 1);
    }

    saveWishlist(list);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-toy-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    toggle(btn);
    refreshButtons();
  });

  document.addEventListener('toy:wishlist:updated', refreshButtons);
  document.addEventListener('DOMContentLoaded', refreshButtons);
})();
